function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.53158 20.025c0-10.766 8.7407-19.507 19.507-19.507 10.804 0 19.507 8.7407 19.507 19.507 0 10.804-8.7032 19.507-19.507 19.507-10.766 0-19.507-8.7032-19.507-19.507z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m7.5445 16.341c0-1.8007 1.463-3.2637 3.2637-3.2637h15.418c1.8007 0 3.2262 1.463 3.2262 3.2637v13.017c0 1.8007-1.4255 3.2262-3.2262 3.2262h-15.418c-1.8007 0-3.2637-1.4255-3.2637-3.2262z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.5445 16.341c0-1.8007 1.463-3.2637 3.2637-3.2637h15.418c1.8007 0 3.2262 1.463 3.2262 3.2637v13.017c0 1.8007-1.4255 3.2262-3.2262 3.2262h-15.418c-1.8007 0-3.2637-1.4255-3.2637-3.2262z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.846 13.077h15.343c1.8007 0 3.2637 1.463 3.2637 3.2262v3.6764h-21.908v-3.6764c0-1.7632 1.5006-3.2262 3.3012-3.2262z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.846 13.077h15.343c1.8007 0 3.2637 1.463 3.2637 3.2262v3.6764h-21.908v-3.6764c0-1.7632 1.5006-3.2262 3.3012-3.2262z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6413px"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m5.5938 14.128c0-1.8007 1.5006-3.3012 3.3012-3.3012h15.193c1.8007 0 3.2637 1.5006 3.2637 3.3012v13.092c0 1.8007-1.463 3.2637-3.2637 3.2637h-15.193c-1.8007 0-3.3012-1.463-3.3012-3.2637z",
  fill: "#fff"
}), React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m12.646 21.881c0-0.18757 0.18158-0.37514 0.36317-0.37514h9.1882c0.18158 0 0.32685 0.18757 0.32685 0.37514v1.388c0 0.18757-0.14527 0.33763-0.32685 0.33763h-9.1882c-0.18158 0-0.36317-0.15006-0.36317-0.33763z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m8.4449 22.556c0-0.56271 0.48768-1.0504 1.0504-1.0504 0.60022 0 1.0504 0.48768 1.0504 1.0504 0 0.60022-0.45017 1.0504-1.0504 1.0504-0.56271 0-1.0504-0.45017-1.0504-1.0504z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m12.646 25.85c0-0.18757 0.14527-0.33763 0.32685-0.33763h9.2608c0.18158 0 0.29054 0.15006 0.29054 0.33763v1.313c0 0.18757-0.10895 0.30011-0.29054 0.30011h-9.2608c-0.18158 0-0.32685-0.11254-0.32685-0.30011z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m8.4449 26.563c0-0.56271 0.48768-1.0504 1.0504-1.0504 0.60022 0 1.0504 0.48768 1.0504 1.0504 0 0.60022-0.45017 1.0504-1.0504 1.0504-0.56271 0-1.0504-0.45017-1.0504-1.0504z"
})), React.createElement("path", {
  d: "m8.8575 10.827h15.268c1.8007 0 3.2262 1.3973 3.2262 3.0673v3.4762h-21.758v-3.4762c0-1.67 1.463-3.0673 3.2637-3.0673z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m8.4449 13.802c0-0.19063 0.22508-0.35402 0.48768-0.35402h15.118c0.2626 0 0.45017 0.1634 0.45017 0.35402v1.3889c0 0.19063-0.18757 0.32679-0.45017 0.32679h-15.118c-0.2626 0-0.48768-0.13616-0.48768-0.32679z",
  fill: "#adb9ca"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m5.5938 14.128c0-1.8007 1.5185-3.3012 3.3407-3.3012h15.375c1.8222 0 3.3028 1.5006 3.3028 3.3012v13.092c0 1.8007-1.4806 3.2637-3.3028 3.2637h-15.375c-1.8222 0-3.3407-1.463-3.3407-3.2637z"
}), React.createElement("g", {
  className: "icon-tertiary"
}, React.createElement("path", {
  d: "m12.646 21.881c0-0.18757 0.18158-0.37514 0.36317-0.37514h9.1882c0.18158 0 0.32685 0.18757 0.32685 0.37514v1.388c0 0.18757-0.14527 0.33763-0.32685 0.33763h-9.1882c-0.18158 0-0.36317-0.15006-0.36317-0.33763z"
}), React.createElement("path", {
  d: "m8.4449 22.556c0-0.56271 0.48768-1.0504 1.0504-1.0504 0.60022 0 1.0504 0.48768 1.0504 1.0504 0 0.60022-0.45017 1.0504-1.0504 1.0504-0.56271 0-1.0504-0.45017-1.0504-1.0504"
}), React.createElement("path", {
  d: "m12.646 25.85c0-0.18757 0.14527-0.33763 0.32685-0.33763h9.2608c0.18158 0 0.29054 0.15006 0.29054 0.33763v1.313c0 0.18757-0.10895 0.30011-0.29054 0.30011h-9.2608c-0.18158 0-0.32685-0.11254-0.32685-0.30011z"
}), React.createElement("path", {
  d: "m8.4449 26.563c0-0.56271 0.48768-1.0504 1.0504-1.0504 0.60022 0 1.0504 0.48768 1.0504 1.0504 0 0.60022-0.45017 1.0504-1.0504 1.0504-0.56271 0-1.0504-0.45017-1.0504-1.0504"
})), React.createElement("path", {
  className: "icon-tertiary",
  d: "m8.8575 10.501h15.268c1.8007 0 3.2262 1.7101 3.2262 3.7538v4.2543h-21.758v-4.2543c0-2.0437 1.463-3.7538 3.2637-3.7538z"
}), React.createElement("path", {
  d: "m8.4449 13.802c0-0.19063 0.22508-0.35402 0.48768-0.35402h15.118c0.2626 0 0.45017 0.1634 0.45017 0.35402v1.3889c0 0.19063-0.18757 0.32679-0.45017 0.32679h-15.118c-0.2626 0-0.48768-0.13616-0.48768-0.32679z"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m18.533 19.526h5.9647v5.0269l11.292-10.054-11.292-10.054v5.0269h-5.9647z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  opacity: 0.99
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.53154 20.025c0-10.766 8.7407-19.507 19.507-19.507 10.804 0 19.507 8.7407 19.507 19.507 0 10.804-8.7032 19.507-19.507 19.507-10.766 0-19.507-8.7032-19.507-19.507",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m18.533 19.526h5.9647v5.0269l11.292-10.054-11.292-10.054v5.0269h-5.9647z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeMiterlimit: 8
});

var SvgSurveyModelTabPublish = function SvgSurveyModelTabPublish(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabPublish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Publish.20571853.svg";
export { ForwardRef as ReactComponent };